import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "../../axios";
import { Link, useNavigate } from "react-router-dom";

const WorkList = () => {
  const [works, setWorks] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const handleEdit = (id) => {
    // window.location.href = `/admin/addWork/${id}`;
    navigate(`/admin/addWork/${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this Image?")) {
      axios
        .delete(`/our-work/${id}`)
        .then(() => {
          const updated = works.filter((work) => work.id !== id);
          setWorks(updated);
          setFilteredData(updated);
        })
        .catch((err) => {
          console.error("Error deleting work:", err);
        });
    }
  };

  useEffect(() => {
    axios
      .get("/our-work")
      .then((res) => {
        const formatted = res.data.map((item) => ({
          ...item,
          title: item.work_name,
          imageUrl: item.image_url,
        }));
        setWorks(formatted);
        setFilteredData(formatted);
      })
      .catch((err) => {
        console.error("Failed to fetch works:", err);
      });
  }, []);

  useEffect(() => {
    const filtered = works.filter((work) =>
      work.title.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  }, [searchText, works]);

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1,
      width: "100px",
      cell: (_, index) => <div className="text-center">{index + 1}</div>,
    },
    {
      name: "Work Name",
      selector: (row) => row.title,
      sortable: true,
      cell: (row) => <div className="text-center">{row.title}</div>,
    },
    {
      name: "Image",
      cell: (row) => (
        <div className="text-center">
          {row.imageUrl ? (
            <img
              src={row.imageUrl}
              alt={row.title}
              style={{ width: "80px", height: "auto", objectFit: "cover" }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/no-image";
              }}
            />
          ) : (
            "No Image"
          )}
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="action-buttons justify-content-center">
          <button
            className="edit-btn"
            onClick={() => handleEdit(row.id)}
            title="Edit">
            <i className="bi bi-pencil"></i>
          </button>
          <button
            className="delete-btn"
            onClick={() => handleDelete(row.id)}
            title="Delete">
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
      width: "150px",
    },
  ];

  return (
    <div className="main-content">
      <div className="page-header">
        <h4>Works</h4>
        <Link to="/admin/addWork" className="text-decoration-none">
          <button className="gold-add-btn text-white">+ Add Work</button>
        </Link>
      </div>

      <input
        type="text"
        className="search-input my-4"
        placeholder="Search work..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />

      <div className="data-table-container">
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          paginationPerPage={10}
          highlightOnHover
          responsive
          className="data-table"
          persistTableHead={true}
          noDataComponent={
            <div className="text-center py-4">No data found</div>
          }
        />
      </div>
    </div>
  );
};

export default WorkList;
